<template>
  <div>
    <div v-if="isLoading" class="loading-card-wrapper bg-black"></div>
    <div v-else-if="this.campaignExist">
      <div
        id="aoneCarouselControls"
        class="carousel slide"
        data-ride="carousel"
        data-interval="false"
      >
        <ol v-if="formattedCampaigns.length > 1" class="carousel-indicators">
          <li
            v-for="(_, i) in formattedCampaigns.length"
            data-target="#aoneCarouselControls"
            :data-slide-to="i"
            :key="i"
            :class="{ 'active': i === 0 }"
            @click="handleCarouselControlClick('slide indicator')"
          ></li>
        </ol>
        <div class="carousel-inner">
          <div
            class="carousel-item"
            v-for="(campaign, i) in formattedCampaigns"
            :key="campaign.id"
            :class="{ active: i === 0 }"
          >
            <div
              class="campaign-card-wrapper d-flex align-items-center"
              :style="getBackgroundStyle(campaign)"
            >
              <div class="campaign-container container">
                <div class="row">
                  <div class="col-12 col-xl-10 pb-4">
                    <div class="mb-4">
                      <div class="campaign-title text-overflow-ellipsis">
                        {{ campaign.bannerTitle }}
                      </div>
                      <div
                        v-if="campaign.bannerSubTitle"
                        class="campaign-sub-title text-overflow-ellipsis mt-2"
                      >
                        {{ campaign.bannerSubTitle }}
                      </div>
                    </div>
                    <div>
                      <span
                        class="campaign-btn"
                        @click="navigateToCampaignPost(campaign)"
                        v-if="campaign.bannerLink && campaign.bannerLink.url"
                      >
                        <img
                          v-if="
                            campaign.bannerType ===
                            CONSTANTS.LUMI_CAMPAIGN_BANNER
                          "
                          src="@/assets/image/lumi-character.png"
                          class="lumi-campaign-image"
                          alt="Lumi"
                        />
                        {{
                          campaign.bannerLink
                            ? campaign.bannerLink.description
                            : ""
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- carousel navigation -->
        <div v-if="formattedCampaigns.length > 1">
          <!-- previous button -->
          <a
            class="carousel-control-prev"
            href="#aoneCarouselControls"
            role="button"
            data-slide="prev"
            @click="handleCarouselControlClick('previous')"
          >
            <font-awesome-icon
              class="chevron-left-icon fa-lg carousel-controls-arrow"
              :icon="['fas', 'chevron-left']"
            />
            <span class="sr-only">Previous</span>
          </a>
          <!-- next button -->
          <a
            class="carousel-control-next"
            href="#aoneCarouselControls"
            role="button"
            data-slide="next"
            @click="handleCarouselControlClick('next')"
          >
            <font-awesome-icon
              class="chevron-left-icon fa-lg carousel-controls-arrow"
              :icon="['fas', 'chevron-right']"
            />

            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
    <!-- default greeting banner -->
    <div v-else>
      <div class="greeting-card-wrapper" :style="backgroundStyle">
        <div class="campaign-container container">
          <div class="campaign-title text-left">
            <div>{{ homepageHeaderGreeting }}</div>
          </div>
          <div class="greeting text-left">
            <div>{{ CONSTANTS.HOMEPAGE_GENERIC_GREETING }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment/moment";
import { mapGetters } from "vuex";
import * as CONSTANTS from "../../store/constants";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "campaign-card",
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      CONSTANTS,
      imgData: null,

      bannerTitle: null,
      bannerSubTitle: null,
      bannerType: null,
      bannerLink: null,
      bannerDate: null,
      bannerAdditionalInfo: null,

      campaignExist: false,
      isLoading: false,

      availableCampaigns: [],
      formattedCampaigns: [],
    };
  },
  created() {
    this.initializeCampaignCard();
  },
  computed: {
    backgroundStyle() {
      let gradientPrefix =
        "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),";
      let defaultImgUrl = CONSTANTS.HOMEPAGE_DEFAULT_HERO_IMG;
      return this.imgData
        ? {
            "background-image": `${gradientPrefix} url(${this.imgData.url})`,
            "background-position": "50% 50% !important",
          }
        : {
            "background-image": `${gradientPrefix} url(${defaultImgUrl})`,
            "background-position": "25% 43% !important",
          };
    },
    ...mapGetters(["user"]),
    homepageHeaderGreeting() {
      if (!this.user || !this.user.firstName || !this.user.lastName) {
        return CONSTANTS.HOMEPAGE_GENERIC_GREETING;
      }
      let formattedFirstName = this.user.firstName;
      let firstNameArr = formattedFirstName.split(" ");
      if (firstNameArr) {
        formattedFirstName = firstNameArr[0];
      }
      return `Welcome, ${formattedFirstName}!`;
    },
  },
  methods: {
    async initializeCampaignCard() {
      this.isLoading = true;
      let currentDateTime = moment().toISOString();
      let campaignInfoResponse = await api.getCampaignInfo(currentDateTime);
      this.checkIfCampaignExist(campaignInfoResponse);

      if (this.campaignExist) {
        await this.formatCampaigns();
      }

      this.isLoading = false;
    },

    checkIfCampaignExist(campaignInfoResponse) {
      if (campaignInfoResponse) {
        this.availableCampaigns = campaignInfoResponse.value;

        if (this.availableCampaigns && this.availableCampaigns.length > 0) {
          this.campaignExist = true;
        }
      }
    },

    getDateStr(date) {
      let dateStrFormat = "dddd, MMMM D, YYYY";
      return moment(date).format(dateStrFormat);
    },

    navigateToCampaignPost(campaign) {
      if (campaign.bannerLink) {
        let subEvent = `${campaign.bannerTitle} - ${campaign.bannerLink.url}`;
        this.trackCampaign(subEvent);
        window.open(
          campaign.bannerLink.url,
          Vue.prototype.$getAoneLinkTarget(campaign.bannerLink.url)
        );
      }
    },

    async formatCampaigns() {
      let requests = this.constructCampaignImageRequests(
        this.availableCampaigns
      );
      let imagesResponse = await api.batchGetCampaignImages(requests);
      let campaignIdToImgMap = this.constructImageMap(imagesResponse);

      for (let i = 0; i < this.availableCampaigns.length; i++) {
        let campaign = this.availableCampaigns[i];

        let campaignConfig = {
          id: campaign.id,
          bannerTitle: campaign.fields.BannerTitle,
          bannerSubTitle: campaign.fields.Subtitle,
          bannerType: campaign.fields.BannerType,
          bannerImage: campaignIdToImgMap[campaign.id],
          bannerLink: getBannerLinkDetails.call(this, campaign),
          bannerAdditionalDetails: getBannerAdditionalDetails.call(
            this,
            campaign
          ),
        };

        this.formattedCampaigns.push(campaignConfig);
      }
    },

    getBackgroundStyle(campaign) {
      let gradientPrefix =
        "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),";
      let style = {
        "background-image": `${gradientPrefix} url(${campaign.bannerImage.url})`,
        "background-position": "50% 50% !important",
      };

      return style;
    },

    constructCampaignImageRequests(campaigns) {
      if (!campaigns || campaigns.length == 0) return null;

      let requests = [];
      campaigns.forEach((c) => {
        requests.push({
          id: c.id,
          method: "GET",
          url: this.constructCampaignImageRequestUrl(c),
        });
      });

      return requests;
    },

    constructCampaignImageRequestUrl(campaign) {
      // extract uuid from eTag
      let itemId = campaign.eTag.replace('"', "").split(",")[0];
      let url = `sites/${SHAREPOINT_SITE_ID}/lists/${CAMPAIGN_ITEM_ID}/items/${itemId}/driveItem/thumbnails?select=c3000x3000_crop`;
      return url;
    },

    constructImageMap(batchImageResponse) {
      let map = {};
      batchImageResponse.responses.forEach((res) => {
        let imgList = res.body.value[0];
        // default to first returned img in list
        map[res.id] = Object.entries(imgList)[0][1];
      });

      return map;
    },

    handleCarouselControlClick(direction) {
      this.trackCampaignCarouselClick(direction);
    },
  },
};

function getBannerLinkDetails(mostRecentCampaign) {
  let bannerLink = {};
  if (mostRecentCampaign.fields.BannerButton) {
    bannerLink.description = mostRecentCampaign.fields.BannerButton.Description;
    bannerLink.url = mostRecentCampaign.fields.BannerButton.Url;
  }

  return bannerLink;
}

function getBannerAdditionalDetails(mostRecentCampaign) {
  let bannerAdditionalInfo = {};
  bannerAdditionalInfo.date = mostRecentCampaign.fields.ExpiryDate;
  if (mostRecentCampaign.fields.BannerAdditionalInfo) {
    bannerAdditionalInfo.description =
      mostRecentCampaign.fields.BannerAdditionalInfo.Description;
    bannerAdditionalInfo.url =
      mostRecentCampaign.fields.BannerAdditionalInfo.Url;
  }

  return bannerAdditionalInfo;
}
</script>

<style scoped>
.loading-card-wrapper,
.campaign-card-wrapper,
.greeting-card-wrapper {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.campaign-card-wrapper {
  min-height: 264px;
}
.loading-card-wrapper,
.greeting-card-wrapper {
  min-height: 180px;
}

.campaign-title {
  font-family: artifaktElementBold !important;
  font-style: normal;
  font-weight: 800;
  font-size: 30px;
  color: #ffffff;
  line-height: 1.1;
}

.campaign-sub-title {
  font-family: artifaktElementRegular !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 1.2;
}

.campaign-btn {
  text-transform: none;
  font-family: artifaktElementBold !important;
  font-weight: 800;
  font-size: 18px !important;
  line-height: 34px;
  color: #ffffff;
  padding: 12px 24px;
  background: var(--secondary-color);
  border-radius: 63px;
}

.campaign-btn:hover {
  cursor: pointer;
}

.campaign-date {
  font-family: artifaktElementRegular !important;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.4;
  color: #ffffff;
}

.campaign-container {
  padding-top: 44px;
  padding-bottom: 66px;
}

.greeting {
  font-family: artifaktElementRegular !important;
  font-style: normal;
  font-size: 30px;
  line-height: 1;
  margin-top: 3px;
  color: #ffffff;
}

.campaign-addition-link {
  text-decoration: underline;
}

.campaign-addition-link:hover {
  cursor: pointer;
}

.bg-black {
  background: #000;
}

.outage-wrapper {
  min-height: 52px;
}
.lumi-campaign-image {
  width: 45px;
  height: 45px;
  margin-top: 1px;
  margin-left: -15px;
}

/* carousel styles */
.carousel-control-prev {
  display: none;
}
.carousel-control-prev,
.carousel-control-next {
  width: 50px;
  border: 2px solid rgba(255, 255, 255, 0);
}
.carousel-controls-arrow {
  height: 50px;
  width: auto;
  color: white;
  opacity: 0.9;
}

@media (min-width: 1450px) {
  .carousel-control-prev {
    display: flex;
    left: calc((100% - 1420px) / 2);
  }
  .carousel-control-next {
    right: calc((100% - 1420px) / 2);
  }
}

.carousel-indicators {
  bottom: 34px;
}

.carousel-indicators li {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border-top: unset;
  border-bottom: unset;
}
</style>
